import { get } from "./api";
import routes from "./end-points";

export const categoriesApi = {
    initCategory: (id) => get(routes.categories.init(id)),
    initCategoryPosterUrl: (id, width, height) => routes.categories.initCoursePoster(id, width, height),
};
